<template>
   <div v-if="refreshDom" class="login-page">
     <img class="login-bg" :src="file[fileId]"/>
    <PasswordCard></PasswordCard>
   </div>
</template>

<script lang='js'>
import Vue from 'vue'
import PasswordCard from '@/components/Login/PasswordCard'
import { mapState, mapGetters } from 'vuex'

const ForgetPassword = Vue.extend({
  name: 'ForgetPassword',
  data: function () {
    return {
      refreshDom: true,
      fileId: 1002
    }
  },
  components: {
    PasswordCard
  },
  computed: {
    ...mapState({
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      isFileChange: 'resource/size'
    })
  },
  watch: {
    isFileChange () {
      this.refresh()
    }
  },
  mounted () {
    if (!this.$store.state.resource.status[this.fileId]) {
      this.$store.dispatch('resource/getFileTypePublic', this.fileId)
    }
  },
  methods: {
    refresh () {
      this.refreshDom = false
      this.$nextTick(() => {
        this.refreshDom = true
      })
    }
  }
})

export default ForgetPassword
</script>

<style>
.login-page {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  /* background-image: url('../../assets/Login/ditu.jpg'); */
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
}
.login-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
